import { Button, Grid, TextField, makeStyles } from '@material-ui/core'
import { useHomeStore } from 'context/HomeStore'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import { SendIcon } from 'asterX-UIkit/Icons'

const useStyles = makeStyles(theme => ({
  inputItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexBasis: '100%',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  button: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '48px'
    }
  },
  textField: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px'
    }
  }
}))

export const ChatInput = () => {
  const classes = useStyles()

  const handleClick = () => {
    document.getElementById('fileInput').click()
  }
  const {
    homeStore: { message, requestList },
    homeStoreFunc: { setMessage, handleSendChat, handleUpload }
  } = useHomeStore()

  const isDisabled = () => {
    return (
      !requestList.adminFullname ||
      ['Завершен', 'Отменен', 'Отказан'].includes(requestList.status)
    )
  }

  return (
    <Grid
      item
      container
      xs={12}
      md={12}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={2} md={2} className={classes.inputItem}>
        <Button
          disabled={isDisabled()}
          variant="outlined"
          color="default"
          onClick={handleClick}
        >
          <AttachFileIcon />
          <input
            id="fileInput"
            hidden
            accept="image/*"
            multiple
            type="file"
            onChange={e => handleUpload(e, true)}
          />
        </Button>
      </Grid>
      <Grid item xs={8} md={8} className={classes.inputItem}>
        <TextField
          disabled={isDisabled()}
          fullWidth
          placeholder="Сообщение..."
          value={message}
          onChange={e => setMessage(e.target.value)}
        />
      </Grid>
      <Grid item xs={2} md={2} className={classes.inputItem}>
        <Button
          disabled={isDisabled()}
          variant="contained"
          color="primary"
          onClick={() => handleSendChat()}
        >
          <SendIcon />
        </Button>
      </Grid>
    </Grid>
  )
}
